import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_grid = _resolveComponent("my-grid")!

  return (_openBlock(), _createBlock(_component_my_grid, {
    data: _ctx.allPartners,
    columns: _ctx.columns,
    "initial-sort": _ctx.initialSort,
    filterable: true,
    groupable: true
  }, null, 8, ["data", "columns", "initial-sort"]))
}